import React from "react";

export const About = () => {
  return (
    <div
      className={`bg-white  text-[16px] sm:text-[18px] text-justify w-full h-full flex justify-center items-center rounded-lg overflow-y-scroll no-scrollbar`}
    >
      <div
        className={`text-justify p-4 flex flex-col overflow-auto ${
          window.innerWidth > 900 ? "max-w-[80%]" : ""
        }`}
        style={{ maxHeight: "100%" }}
      >
        <div className="mt-8 text-[20px] sm:text-[24px]">
          <p
            style={{
              fontFamily: "'Antonio', sans-serif",
              flex: "1 1 0%",
              fontWeight: "50",
              lineHeight: "1em",
              textAlign: "center",
              color: "black",
              letterSpacing: -0.3,
              whiteSpace: "nowrap",
              marginBottom: 20,
            }}
          >
            Welcome to Reealtech Technologies Pvt. Ltd.
          </p>
        </div>
        <div className="mt-8 text-[16px] sm:text-[20px]">
          <p
            style={{
              fontFamily: "'Antonio', sans-serif",
              flex: "1 1 0%",
              fontWeight: "50",
              lineHeight: "1em",
              textAlign: "left",
              color: "black",
              letterSpacing: -0.3,
              whiteSpace: "nowrap",
              marginBottom: 20,
            }}
          >
            Building the Future of Digital Commerce
          </p>
        </div>
        <div
          style={{
            fontFamily: "'Rubik', sans-serif",
            fontWeight: "20",
            lineHeight: "2em",
            color: "black",
            letterSpacing: -0.5,
            whiteSpace: "normal",
            marginBottom: 15,
          }}
        >
          At Reealtech Technologies Pvt. Ltd., we believe the internet is ready
          for its next evolution.
        </div>
        <div
          style={{
            fontFamily: "'Rubik', sans-serif",
            fontWeight: "20",
            lineHeight: "2em",
            color: "black",
            letterSpacing: -0.5,
            whiteSpace: "normal",
            marginBottom: 15,
          }}
        >
          For decades, online experiences have relied on static images, videos,
          and endless scrolling. While these formats have transformed how people
          discover products and properties, they still fall short of the
          confidence and engagement created by experiencing something in person.
        </div>
        <div
          style={{
            fontFamily: "'Rubik', sans-serif",
            fontWeight: "20",
            lineHeight: "2em",
            color: "black",
            letterSpacing: -0.5,
            whiteSpace: "normal",
            marginBottom: 15,
          }}
        >
          Our mission is simple:{" "}
          <span className="font-bold">
            bridge the gap between the physical and digital worlds.
          </span>
        </div>
        <div
          style={{
            fontFamily: "'Rubik', sans-serif",
            fontWeight: "20",
            lineHeight: "2em",
            color: "black",
            letterSpacing: -0.5,
            whiteSpace: "normal",
            marginBottom: 15,
          }}
        >
          We are building the technology that enables businesses to create
          intelligent, immersive digital experiences where customers can walk
          through spaces, interact with products, ask questions naturally, and
          make informed decisions with confidence.
        </div>
        <div className="mt-8 text-[20px] sm:text-[24px]">
          <p
            style={{
              fontFamily: "'Antonio', sans-serif",
              flex: "1 1 0%",
              fontWeight: "50",
              lineHeight: "1em",
              textAlign: "center",
              color: "black",
              letterSpacing: -0.3,
              whiteSpace: "nowrap",
              marginBottom: 20,
            }}
          >
            Reealtech is Building
          </p>
        </div>
        <div className="mt-8 text-[16px] sm:text-[20px]">
          <p
            style={{
              fontFamily: "'Antonio', sans-serif",
              flex: "1 1 0%",
              fontWeight: "50",
              lineHeight: "1em",
              textAlign: "left",
              color: "black",
              letterSpacing: -0.3,
              whiteSpace: "nowrap",
              marginBottom: 20,
            }}
          >
            ASTRA3D: The Future of Online Retail and Virtual Tours
          </p>
        </div>
        <div
          style={{
            fontFamily: "'Rubik', sans-serif",
            fontWeight: "20",
            lineHeight: "2em",
            color: "black",
            letterSpacing: -0.5,
            whiteSpace: "normal",
            marginBottom: 15,
          }}
        >
          Astra3D is our platform for creating interactive 3D virtual stores and
          immersive digital experiences without the complexity of traditional
          game engines. Retailers can showcase products in realistic
          environments, create guided shopping journeys, and provide customers
          with an experience that feels far more engaging than a conventional
          e-commerce website.
        </div>
        <div className="mt-8 text-[16px] sm:text-[20px]">
          <p
            style={{
              fontFamily: "'Antonio', sans-serif",
              flex: "1 1 0%",
              fontWeight: "50",
              lineHeight: "1em",
              textAlign: "left",
              color: "black",
              letterSpacing: -0.3,
              whiteSpace: "nowrap",
              marginBottom: 20,
            }}
          >
            WALKNHOMES: Revolutionizing Real Estate Experiences
          </p>
        </div>
        <div
          style={{
            fontFamily: "'Rubik', sans-serif",
            fontWeight: "20",
            lineHeight: "2em",
            color: "black",
            letterSpacing: -0.5,
            whiteSpace: "normal",
            marginBottom: 15,
          }}
        >
          WalknHomes is our immersive real estate platform where buyers can
          explore properties through high-quality virtual tours before
          scheduling physical visits. By combining interactive spaces with
          intelligent search and AI-powered guidance, we're making property
          discovery faster, more transparent, and more convenient.
        </div>

        <div className="mt-8 text-[16px] sm:text-[20px]">
          <p
            style={{
              fontFamily: "'Antonio', sans-serif",
              flex: "1 1 0%",
              fontWeight: "50",
              lineHeight: "1em",
              textAlign: "left",
              color: "black",
              letterSpacing: -0.3,
              whiteSpace: "nowrap",
              marginBottom: 20,
            }}
          >
            AI That Understands Spaces
          </p>
        </div>
        <div
          style={{
            fontFamily: "'Rubik', sans-serif",
            fontWeight: "20",
            lineHeight: "2em",
            color: "black",
            letterSpacing: -0.5,
            whiteSpace: "normal",
            marginBottom: 15,
          }}
        >
          We're developing AI sales agents that don't simply answer scripted
          questions—they understand products, properties, and customer intent.
        </div>
        <div
          style={{
            fontFamily: "'Rubik', sans-serif",
            fontWeight: "20",
            lineHeight: "2em",
            color: "black",
            letterSpacing: -0.5,
            whiteSpace: "normal",
            marginBottom: 15,
          }}
        >
          Whether helping someone choose the right sofa, compare apartments,
          explain specifications, or recommend products inside a virtual
          showroom, our AI is designed to make every digital experience feel
          like having a knowledgeable sales expert available 24/7.
        </div>

        <div className="mt-8 text-[16px] sm:text-[20px]">
          <p
            style={{
              fontFamily: "'Antonio', sans-serif",
              flex: "1 1 0%",
              fontWeight: "50",
              lineHeight: "1em",
              textAlign: "left",
              color: "black",
              letterSpacing: -0.3,
              whiteSpace: "nowrap",
              marginBottom: 20,
            }}
          >
            Affordable Digital Twin Creation
          </p>
        </div>
        <div
          style={{
            fontFamily: "'Rubik', sans-serif",
            fontWeight: "20",
            lineHeight: "2em",
            color: "black",
            letterSpacing: -0.5,
            whiteSpace: "normal",
            marginBottom: 15,
          }}
        >
          Creating immersive experiences shouldn't require expensive hardware or
          specialized equipment.
        </div>
        <div
          style={{
            fontFamily: "'Rubik', sans-serif",
            fontWeight: "20",
            lineHeight: "2em",
            color: "black",
            letterSpacing: -0.5,
            whiteSpace: "normal",
            marginBottom: 15,
          }}
        >
          That's why we're building software that enables businesses to capture
          high-quality 360° spaces using everyday smartphones. By dramatically
          reducing the cost and complexity of creating digital twins, we're
          making immersive commerce accessible to businesses of every size.
        </div>

        <div className="mt-8 text-[20px] sm:text-[24px]">
          <p
            style={{
              fontFamily: "'Antonio', sans-serif",
              flex: "1 1 0%",
              fontWeight: "50",
              lineHeight: "1em",
              textAlign: "center",
              color: "black",
              letterSpacing: -0.3,
              whiteSpace: "nowrap",
              marginBottom: 20,
            }}
          >
            Our Vision
          </p>
        </div>

        <div
          className="p-4 mb-[-20px]"
          style={{
            fontFamily: "'Rubik', sans-serif",
            fontWeight: "20",
            lineHeight: "2em",
            color: "black",
            letterSpacing: -0.5,
            whiteSpace: "normal",
          }}
        >
          <ul className="list-disc">
            <li>
              We believe every physical business will eventually have an
              intelligent digital twin.
            </li>
            <li>
              Retail stores won't just have websites—they'll have immersive
              virtual stores.
            </li>
            <li>
              Properties won't just have photo galleries—they'll have
              interactive walkthroughs.
            </li>
            <li>
              Customers won't search through FAQs—they'll have conversations
              with AI that truly understands the space they're exploring.
            </li>
          </ul>
        </div>

        <div
          style={{
            fontFamily: "'Rubik', sans-serif",
            fontWeight: "20",
            lineHeight: "2em",
            color: "black",
            letterSpacing: -0.5,
            whiteSpace: "normal",
            marginBottom: 15,
            marginTop: 15,
          }}
        >
          This is the future we're building.
        </div>

        <div className="mt-8 text-[20px] sm:text-[24px]">
          <p
            style={{
              fontFamily: "'Antonio', sans-serif",
              flex: "1 1 0%",
              fontWeight: "50",
              lineHeight: "1em",
              textAlign: "center",
              color: "black",
              letterSpacing: -0.3,
              whiteSpace: "nowrap",
            }}
          >
            Why Choose Reealtech
          </p>
        </div>
        <div
          className="p-4 mb-[-20px]"
          style={{
            fontFamily: "'Rubik', sans-serif",
            fontWeight: "20",
            lineHeight: "2em",
            color: "black",
            letterSpacing: -0.5,
            whiteSpace: "normal",
          }}
        >
          <ul className="list-disc">
            <li>
              <span className="font-bold">Immersive by Design:</span> We create
              experiences that people can explore, interact with, and
              remember—not just browse.
            </li>
            <li>
              <span className="font-bold">AI-First Experiences:</span> Our
              products combine immersive environments with intelligent AI
              assistants that help customers make faster and more confident
              decisions.
            </li>
            <li>
              <span className="font-bold">Accessible Innovation:</span> By
              simplifying content creation and reducing hardware costs, we're
              making advanced immersive technology available to businesses of
              all sizes.
            </li>
            <li>
              <span className="font-bold">Built for Scale:</span> Our
              cloud-native platforms are designed to power everything from a
              single retail showroom to enterprise-scale deployments across
              retail, hospitality, education, and real estate.
            </li>
            <li>
              <span className="font-bold">Customer-Centric Technology:</span>{" "}
              Every feature we build is guided by one question:{" "}
              <span className="font-semibold">
                Does this help businesses create better experiences for their
                customers?
              </span>
            </li>
          </ul>
        </div>
        <div className="mt-8 text-[20px] sm:text-[24px]">
          <p
            style={{
              fontFamily: "'Antonio', sans-serif",
              flex: "1 1 0%",
              fontWeight: "50",
              lineHeight: "1em",
              textAlign: "center",
              color: "black",
              letterSpacing: -0.3,
              whiteSpace: "nowrap",
              marginBottom: 20,
            }}
          >
            Looking Ahead
          </p>
        </div>
        <div
          style={{
            fontFamily: "'Rubik', sans-serif",
            fontWeight: "20",
            lineHeight: "2em",
            color: "black",
            letterSpacing: -0.5,
            whiteSpace: "normal",
            marginBottom: 15,
          }}
        >
          Reealtech is building more than software.
        </div>
        <div
          style={{
            fontFamily: "'Rubik', sans-serif",
            fontWeight: "20",
            lineHeight: "2em",
            color: "black",
            letterSpacing: -0.5,
            whiteSpace: "normal",
            marginBottom: 15,
          }}
        >
          We're building the foundation for a future where digital experiences
          are immersive, intelligent, and as natural as visiting a physical
          space.
        </div>
        <div
          style={{
            fontFamily: "'Rubik', sans-serif",
            fontWeight: "20",
            lineHeight: "2em",
            color: "black",
            letterSpacing: -0.5,
            whiteSpace: "normal",
            marginBottom: 15,
          }}
        >
          Whether it's shopping in a virtual store, exploring a new home,
          interacting with an AI sales expert, or creating digital twins with
          nothing more than a smartphone, we're working toward a world where
          technology removes friction instead of creating it.
        </div>
        <div
          style={{
            fontFamily: "'Rubik', sans-serif",
            fontWeight: "20",
            lineHeight: "2em",
            color: "black",
            letterSpacing: -0.5,
            whiteSpace: "normal",
            marginBottom: 15,
          }}
        >
          The future of commerce isn't flat.
        </div>
        <div
          style={{
            fontFamily: "'Rubik', sans-serif",
            fontWeight: "20",
            lineHeight: "2em",
            color: "black",
            letterSpacing: -0.5,
            whiteSpace: "normal",
            marginBottom: 15,
          }}
        >
          It's immersive. It's intelligent. And we're building it.
        </div>

        <div className="mt-8 text-[20px] sm:text-[24px]">
          <p
            style={{
              fontFamily: "'Antonio', sans-serif",
              flex: "1 1 0%",
              fontWeight: "50",
              lineHeight: "1em",
              textAlign: "center",
              color: "black",
              letterSpacing: -0.3,
              whiteSpace: "nowrap",
              marginBottom: 20,
            }}
          >
            Contact Us
          </p>
        </div>
        <div
          style={{
            fontFamily: "'Rubik', sans-serif",
            fontWeight: "20",
            lineHeight: "2em",
            color: "black",
            letterSpacing: -0.5,
            whiteSpace: "normal",
          }}
        >
          <span className="font-semibold">Email: </span>
          <a href="mailto:support@reealtech.com" className="text-blue-600">
            support@reealtech.com
          </a>
        </div>
        <div
          style={{
            fontFamily: "'Rubik', sans-serif",
            fontWeight: "20",
            lineHeight: "2em",
            color: "black",
            letterSpacing: -0.5,
            whiteSpace: "normal",
          }}
        >
          <span className="font-semibold">Phone: </span>
          <a href="tel:+919265893860" className="text-blue-600">
            +91 (926) 589-3860
          </a>
        </div>
        <div
          style={{
            fontFamily: "'Rubik', sans-serif",
            fontWeight: "20",
            lineHeight: "2em",
            color: "black",
            letterSpacing: -0.5,
            whiteSpace: "normal",
          }}
        >
          <span className="font-semibold">Address: </span>
          <a href="https://share.google/IikExU7s1u7AUleyN" className="text-blue-600">
            Office No. 18, Ashirwad Shopping, Ashirwad Township 1, Udhna, Surat, Gujarat 394210, India.
          </a>
        </div>
      </div>
    </div>
  );
};
